<div class="details-container">
  <h2 class="page-title">Detalhes Financeiros</h2>

  <div class="filter-bar">
    <div class="date-fields">
      <div class="date-field">
        <label for="details-since">Data inicial</label>
        <p-datepicker inputId="details-since" dateFormat="dd/mm/yy" [(ngModel)]="since" [readonlyInput]="true"
          placeholder="Selecione a data inicial" />
      </div>

      <div class="date-field">
        <label for="details-until">Data final</label>
        <p-datepicker inputId="details-until" dateFormat="dd/mm/yy" [(ngModel)]="until" [readonlyInput]="true"
          placeholder="Selecione a data final" />
      </div>

      <button class="btn-pesquisar" (click)="applyDateFilter()" [disabled]="isLoading">Filtrar</button>
    </div>

    <div class="action-buttons">
      <button class="btn-export" (click)="exportToCsv()" [disabled]="isLoading || !rows.length">Exportar CSV</button>
      <button class="btn-refresh" (click)="refresh()" [disabled]="isLoading" title="Atualizar">
        <i class="pi pi-refresh"></i>
      </button>
    </div>
  </div>

  <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>

  <p-table [value]="rows" [loading]="isLoading" [paginator]="true" [rows]="30" [rowsPerPageOptions]="[15, 30, 60]">
    <ng-template pTemplate="header">
      <tr>
        <th>Data</th>
        <th [pTooltip]="formulas.cash_in" tooltipPosition="top">Caixa Recebido (R$)</th>
        <th [pTooltip]="formulas.realized_revenue" tooltipPosition="top">Receita Realizada (R$)</th>
        <th [pTooltip]="formulas.net_realized_result" tooltipPosition="top">Resultado Realizado (R$)</th>
        <th [pTooltip]="formulas.take_rate_cs" tooltipPosition="top">Take Rate CS (R$)</th>
        <th [pTooltip]="formulas.take_rate_lol" tooltipPosition="top">Take Rate LoL (R$)</th>
        <th [pTooltip]="formulas.battle_pass_income" tooltipPosition="top">Passe (R$)</th>
        <th [pTooltip]="formulas.store_income" tooltipPosition="top">Loja (R$)</th>
        <th [pTooltip]="formulas.extra_missions_income" tooltipPosition="top">Missões extras (R$)</th>
        <th [pTooltip]="formulas.extra_missions_outflow" tooltipPosition="top">Saídas missões extras (R$)</th>
        <th [pTooltip]="formulas.cash_out" tooltipPosition="top">Saques Pagos (R$)</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-row>
      <tr>
        <td>{{ row.date | date: 'dd/MM/yyyy' }}</td>
        <td>{{ (row.cash_in || 0) | number: '1.2-2' }}</td>
        <td>{{ (row.realized_revenue || 0) | number: '1.2-2' }}</td>
        <td>{{ (row.net_realized_result || 0) | number: '1.2-2' }}</td>
        <td>{{ (row.take_rate_cs || 0) | number: '1.2-2' }}</td>
        <td>{{ (row.take_rate_lol || 0) | number: '1.2-2' }}</td>
        <td>{{ (row.battle_pass_income || 0) | number: '1.2-2' }}</td>
        <td>{{ (row.store_income || 0) | number: '1.2-2' }}</td>
        <td>{{ (row.extra_missions_income || 0) | number: '1.2-2' }}</td>
        <td>{{ (row.extra_missions_outflow || 0) | number: '1.2-2' }}</td>
        <td>{{ (row.cash_out || 0) | number: '1.2-2' }}</td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="11" class="empty-message">Nenhum dado encontrado.</td>
      </tr>
    </ng-template>
  </p-table>
</div>
